<template>
  <div>
    <b-container fluid>
      <tour-map
        ref="tourMap"
        :tour-ids="[this.tour.id]"
        with-tracking
        popup-type="visit"
        style="width: 100%;"
        :handlers="['b']"
        with-courier
        v-if="this.tour.id"
       />
    </b-container>
    <b-container id="view-tour" v-if="tour">
      <b-row>
        <b-col>
          <b-card>
            <h3>
              <span v-translate="{tourId: tour.id}">Tour <strong>%{tourId}</strong></span>
              <span :title="!notOptimized ? this.$gettext('Optimized Tour 😊') : this.$gettext('This tour has been modified and it IS NOT optimized')" style="display: inline-block; width: 1.1em; height:1.1em; border-radius: 100px; line-height: 1; vertical-align: text-top;" :class="tour.status === 'DRAFT' ? 'bg-danger' : (!notOptimized ? 'bg-success' : 'bg-warning')"></span>
            </h3>
            <hr>
            <b-alert variant="warning" :show="tour.status !== 'DRAFT' && notOptimized && !tour.reprocess">
              <h4 v-translate>This tour has been modified and it IS NOT optimized</h4>
            </b-alert>
            <b-alert variant="warning" :show="tour.reprocess === 1">
              <h4 v-translate>This tour has been modified and it's currently being re-routed</h4>
              <p v-translate>Please, wait a minute and reload the page until it's finished.</p>
            </b-alert>
            <b-row>
              <b-col md="7">
                <h2>
                  <span v-translate="{tourStatus: tour.status}">Status: <strong>%{tourStatus}</strong></span>
                  <small v-if="waiting">(WAITING)</small>
                </h2>
                <p v-translate="{lastUpdated: moment.utc(tour.updated_at).tz($tz).format('L LT')}">Last updated: <strong>%{lastUpdated}</strong></p>
              </b-col>
              <b-col class="text-right">
                <b-button variant="secondary" size="lg" v-b-modal.modalVisitsOverview :disabled="tour.status === 'DRAFT' || visits4Show.length === 0" v-translate>Visits Overview</b-button>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="tour.id">
              <b-col cols="6" md>
                <h6 class="text-muted"><translate>Distance</translate></h6>
                <strong>{{ tour.total_distance || '-' }} km.</strong>
              </b-col>
              <b-col cols="6" md>
                <h6 class="text-muted"><translate>Estimated time</translate></h6>
                <strong>{{ etc }}</strong>
              </b-col>
              <b-col cols="6" md>
                <h6 class="text-muted"><translate>Commission</translate></h6>
                <strong>{{ tour.formatted_courier_commission || '-' }}</strong>
              </b-col>
            </b-row>
            <div v-if="tour.shippings && tour.shippings.length > 0">
              <b-row>
                <b-col v-if="tour.courier_id !== null">
                  <hr class="mt-0">
                  <h4>
                    <translate>Current Courier</translate>
                  </h4>
                  <user-card :user="tour.courier" profile-picture-size="90px" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
        <b-col cols="3" class="text-right" v-if="tour.status !== 'DRAFT' && tour.status !== 'FINISHED' && tour.status !== 'CANCELED'">
          <div>
            <br>
            <b-button block v-b-modal.modalAssignNormal variant="secondary" :disabled="tour.status !== 'READY' || tour.courier_id !== null" v-translate>
              Assign Courier
            </b-button>

            <b-modal id="modalAssignNormal" ref="modalAssignNormal" hide-footer :no-close-on-backdrop="assigning" :no-close-on-esc="assigning" :hide-header-close="assigning" @hide="newCourier = null">
              <template #modal-title><translate>Assign Courier</translate></template>
              <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
              <div class="form-group">
                <label for="search-courier" v-translate>Search for courier by name or email</label>
                <user-autocomplete ref="courierAc" endpoint="companies/users" @selected="onSearchCourierSelected" :restrictToRoles="['courier']" with-picture />
              </div>
              <b-row v-if="newCourier">
                <user-card :user='newCourier' profile-picture-size="90px" />
                <b-col cols="12" class="text-right">
                  <b-button @click="assignCourier" :disabled="assigning">
                    <b-spinner small v-if="assigning"></b-spinner>
                    <translate>Assign!</translate>
                  </b-button>
                </b-col>
              </b-row>
            </b-modal>

          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container id="view-tour" v-if="shippings.length > 0">
      <h3 v-translate>Manage Tour Shippings</h3>
      <b-card v-for="(shipping, index) in shippings" :key="index" class="shipping-item" :class="shipping.status.toLowerCase()">
        <b-row>
          <b-col cols="12" md="6" lg="3" class="shipping-status mb-3 mb-lg-0" order="1">
            <shipping-statuses class="text-muted" :shipping="shipping" />
            <div>
              <strong class="shipping-id"><b-link :to="{name: 'ShippingsEdit', params: {id: shipping.id}}" target="_blank">{{shipping.id | uuid }}</b-link> ({{shippingSizes.find(x => x.id === shipping.size_id).name}})</strong><br>
              <span class="shipping-date">{{moment.utc(shipping.created_at).tz($tz).format('L LT')}}</span>
            </div>

          </b-col>
          <b-col cols="12" md="6" lg="3" class="shipping-origin mb-3 mb-lg-0" order="3" order-lg="2">
            <h5 class="shipping-contact">{{shipping.from_contact}}</h5>
            <p><span class="shipping-address">{{shipping.address_from.formatted_address}}</span>
              <span v-if="(shipping.status !== 'WAITING' && shipping.status !== 'CANCELED') && !isScheduled">
                <br v-if="shipping.from_email || shipping.from_phone">
                {{shipping.from_email}}<br v-if="shipping.from_email">
                {{shipping.from_phone}}
              </span>
            </p>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="shipping-destination mb-3 mb-lg-0" order="4" order-lg="3">
            <h5 class="shipping-contact">{{shipping.to_contact}}</h5>
            <p><span class="shipping-address">{{shipping.address_to.formatted_address}}</span>
              <span v-if="(shipping.status !== 'WAITING' && shipping.status !== 'CANCELED') && !isScheduled">
                <br v-if="shipping.to_email || shipping.to_phone">
                {{shipping.to_email}}<br v-if="shipping.to_email">
                {{shipping.to_phone}}
              </span>
            </p>
          </b-col>
        </b-row>
      </b-card>
    </b-container>

    <b-modal id="modalVisitsOverview" size="lg" ref="modalVisitsOverview" hide-footer>
      <template #modal-title><translate>Visits Overview</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <b-card v-for="(visit, index) in visits4Show" :key="index" :class="visit.visited === 1 ? 'bg-success text-light' : ''">
        <b-row>
          <b-col cols="1">
            <h2>{{index + 1}}</h2>
          </b-col>
          <b-col cols="11">
            <shipping-visit :visit="visit" with-ids />
          </b-col>
        </b-row>
      </b-card>
    </b-modal>

  </div>
</template>

<script>
import {
  TourService
} from '@/services/api'
import DataTransformersMixin from '@/common/dataTransformers'
import UserAutocomplete from '@/components/Autocompletes/UserAutocomplete'
import ShippingVisit from '@/components/Shippings/Visit'
import ShippingStatuses from '@/components/Shippings/Statuses'
import TourMap from '@/components/Maps/TourMap'

export default {
  name: 'ToursEdit',
  title() {
    return this.$gettextInterpolate(this.$gettext('Tour #%{tourId}'), { tourId: this.$options.filters.uuid(this.$route.params.id) })
  },
  components: {
    UserAutocomplete,
    ShippingVisit,
    ShippingStatuses,
    TourMap
  },
  data() {
    return {
      tour: {},
      shippings: [],
      visits4Show: [],
      newCourier: null,
      assigning: false,
      notOptimized: false,
      isScheduled: null, // FAKE
      waiting: false
    }
  },
  mixins: [
    DataTransformersMixin
  ],
  computed: {
    etc() {
      const minutes = this.tour.estimated_completion_time
      if (minutes === null || minutes === undefined) {
        return '-'
      }
      if (minutes < 60) {
        return minutes + ' min'
      }
      return this.moment().startOf('day').add(minutes, 'minutes').format('HH:mm') + ' hs'
    }
  },
  mounted() {
    this.getTour()
  },
  methods: {
    async getTour() {
      this.$store.dispatch('showSpinner')
      const params = {
        includes: [
          'visits',
          'shippings.to_area.regions',
          'courier.courier_available.tracking'
        ]
      }
      return await TourService.get(this.$route.params.id, { params })
        .then(response => {
          if (this.dataTransformers.tours) {
            if (this.dataTransformers.tours.transform) {
              response.body = this.dataTransformers.tours.transform(response.body)
            }
          }
          this.tour = response.data
          this.shippings = this.tour.shippings

          // Vroom Project JSON export for use on http://map.vroom-project.org/
          if (this.tour.shippings && this.tour.shippings.length > 0) {
            console.log(JSON.stringify(
              {
                vehicles: [
                  {
                    id: 2,
                    start: [
                      parseFloat(this.tour.shippings[0].address_from.lng),
                      parseFloat(this.tour.shippings[0].address_from.lat)
                    ],
                    capacity: [
                      40
                    ],
                    skills: [
                      2,
                      14
                    ],
                    time_window: [
                      1600416000,
                      1600430400
                    ],
                    breaks: [{
                      id: 2,
                      service: 300,
                      time_windows: [
                        [
                          1600423200,
                          1600425000
                        ]
                      ]
                    }]
                  }
                ],
                shipments: this.tour.shippings.map((x, i) => {
                  return {
                    amount: [1],
                    pickup: {
                      id: i + 1,
                      location: [
                        parseFloat(x.address_from.lng),
                        parseFloat(x.address_from.lat)
                      ],
                      description: x.address_from.formatted_address,
                      service: 300
                    },
                    delivery: {
                      id: i + 1 + 1000,
                      location: [
                        parseFloat(x.address_to.lng),
                        parseFloat(x.address_to.lat)
                      ],
                      description: x.address_to.formatted_address,
                      service: 300
                    }
                  }
                })
              }
            ))
          }

          this.visits4Show = []
          let prevVisit
          response.data.visits.forEach(visit => {
            this.notOptimized = this.notOptimized === true || visit.order === null || false
            if (visit.type + '-' + visit.place_id !== prevVisit) {
              visit.shipping_ids = [visit.shipping_id]
              this.visits4Show.push(visit)
            } else {
              if (visit.visited === 1) {
                this.visits4Show[(this.visits4Show.length - 1)].visited = 1
              }
              this.visits4Show[(this.visits4Show.length - 1)].shipping_ids.push(visit.shipping_id)
            }
            prevVisit = visit.type + '-' + visit.place_id
          })
          this.tour.visits4Show = this.visits4Show

          this.shippings.forEach(shipping => {
            if (shipping.status === 'WAITING' && this.waiting !== true) {
              this.waiting = true
            } else if (shipping.status !== 'WAITING') {
              this.waiting = false
            }
          })

          this.$store.dispatch('hideSpinner')
          // this.$refs.tourMap.fetchTours()
        }, error => {
          this.$store.dispatch('hideSpinner')
          if (error.status === 404) {
            this.$root.$children[0].$refs.simplert.openSimplert({
              title: 'ERROR',
              message: this.$gettext('The tour does not exist or does not belong to your company.'),
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            })
            this.$router.push({ name: 'tourList' })
          }
        })
    },
    reloadTour() {
      this.$nextTick(() => {
        this.getTour()
      })
    },
    onSearchCourierSelected(item) {
      this.newCourier = item
      this.$refs.courierAc.searchQuery = ''
    },
    assignCourier() {
      if (this.assigning) {
        return
      }
      if (
        confirm(this.$gettext('Are you sure you want to ASSIGN the current tour to the selected courier?'))
      ) {
        // the assign is synchronous on the backend and can take a while: block resending meanwhile
        this.assigning = true
        TourService.assign(this.$route.params.id, this.newCourier.id)
          .then(response => {
            this.assigning = false
            this.reloadTour()
            this.$refs.modalAssignNormal.hide()
          }, error => {
            this.assigning = false
            if (![404, 428].includes(error.status)) {
              return
            }
            this.$root.$children[0].$refs.simplert.openSimplert({
              title: 'ERROR',
              message: this.$gettext('Sorry! The Tour has been taken by other courier before.'),
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            })
            this.$refs.modalAssignNormal.hide()
            if (error.status === 404) {
              this.$router.push({ name: 'tourList' })
            } else {
              this.reloadTour()
            }
          })
      }
    }
  }
}
</script>
